import { IParamsById } from '~api/interfaces/IParamsById';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/ProductService';
import { ProductSkuRepository } from '../repositories/ProductSkuRepository';

export class ProductSkusRequestedUseCase {
    private productSkuRepository: ProductSkuRepository;
    private paramsById: IParamsById;
    private query?: string;

    constructor(paramsById: IParamsById, query?: string) {
        this.paramsById = paramsById;
        this.query = query;
        this.productSkuRepository = diContainer.get(serviceNames.productSkuRepository);
    }

    public execute = async () => {
        return this.productSkuRepository.getProductData(this.paramsById, this.query);
    };
}
